export const drawerCollapsedWidth = 96;
export const drawerWidth = "100%";

/** Altura da barra de menu horizontal (desktop) */
export const adminMenuBarHeight = 44;
